module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "tweetPictures"
    }
  }, [_c('div', {
    staticClass: "faultClass container"
  }, [_c('h4', [_vm._v("回收图文管理")]), _vm._v(" "), _c('ul', {
    staticClass: "clearfix"
  }, [_vm._l((_vm.faultClassLists), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "faultClassListPart listPart",
      class: {
        'warning-border': item.state === 0
      },
      on: {
        "click": function($event) {
          return _vm.selectFaultClass(item, index)
        }
      }
    }, [_vm._v("\n        " + _vm._s(item.memo) + "\n        "), _vm._v(" "), _c('span', {
      staticClass: "exitBtn",
      class: {
        warning: item.state === 0
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.exitFaultClass(item)
        }
      }
    }, [_vm._v("编辑")])])
  }), _vm._v(" "), _c('li', {
    staticClass: "addContent",
    on: {
      "click": function($event) {
        return _vm.newFaultClass()
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  })])], 2), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.textMenu[_vm.dialogMenuStatus],
      "visible": _vm.dislogFaultClass,
      "close-on-click-modal": false,
      "width": "600px"
    },
    on: {
      "update:visible": function($event) {
        _vm.dislogFaultClass = $event
      },
      "close": function($event) {
        return _vm.emptyDialog('FaultClassForm')
      }
    }
  }, [_c('el-form', {
    ref: "FaultClassForm",
    attrs: {
      "model": _vm.FaultClassForm,
      "label-width": "100px",
      "label-position": _vm.labelPosition,
      "rules": _vm.FaultClassFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "链接名称："
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择链接类型"
    },
    model: {
      value: (_vm.FaultClassForm.linkType),
      callback: function($$v) {
        _vm.$set(_vm.FaultClassForm, "linkType", $$v)
      },
      expression: "FaultClassForm.linkType"
    }
  }, _vm._l((_vm.pictureLinkTypes), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.paraName,
        "value": item.paraValue
      }
    })
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "explain"
  }, [_c('p', [_vm._v("\n              外部链接: 使用http协议，如：http://www.baidu.com，小程序支持跳出\n            ")]), _vm._v(" "), _c('p', [_vm._v("web-view: 小程序内部打开页面: 使用http协议")]), _vm._v(" "), _c('p', [_vm._v("小程序间跳转: 请使用JSON压缩格式,{\"appId\":\"\",path:\"\"}")]), _vm._v(" "), _c('p', [_vm._v("小程序页面: 跳转小程序页面 如：/pages/index")])])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "链接地址：",
      "prop": "chainedAddress"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.FaultClassForm.chainedAddress),
      callback: function($$v) {
        _vm.$set(_vm.FaultClassForm, "chainedAddress", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "FaultClassForm.chainedAddress"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "排序：",
      "prop": "sort"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": "",
      "type": "number",
      "min": 0,
      "max": 99
    },
    model: {
      value: (_vm.FaultClassForm.sort),
      callback: function($$v) {
        _vm.$set(_vm.FaultClassForm, "sort", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "FaultClassForm.sort"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "图文描述"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": "",
      "type": "textarea"
    },
    model: {
      value: (_vm.FaultClassForm.memo),
      callback: function($$v) {
        _vm.$set(_vm.FaultClassForm, "memo", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "FaultClassForm.memo"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "图文归属:"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择归属"
    },
    model: {
      value: (_vm.FaultClassForm.memo1),
      callback: function($$v) {
        _vm.$set(_vm.FaultClassForm, "memo1", $$v)
      },
      expression: "FaultClassForm.memo1"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "极吼吼回收小程序",
      "value": "JHH-recovery"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "触屏一体机",
      "value": "JHH-touch"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "类型："
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择类型"
    },
    model: {
      value: (_vm.FaultClassForm.memo2),
      callback: function($$v) {
        _vm.$set(_vm.FaultClassForm, "memo2", $$v)
      },
      expression: "FaultClassForm.memo2"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "首页广告-popup弹出层",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "首页-中部广告位",
      "value": "2"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "首页底部广告",
      "value": "3"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "首页banner轮播图",
      "value": "4"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "我的-中部广告位",
      "value": "10"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "我的-底部广告",
      "value": "11"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "活动-推广-banner",
      "value": "20"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "活动-推广-详情",
      "value": "21"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "clearfix",
    attrs: {
      "label": "展示图片：",
      "prop": "images"
    }
  }, [_c('el-upload', {
    staticClass: "avatar-uploader fl",
    attrs: {
      "data": _vm.postData,
      "accept": _vm.acceptImage,
      "action": "https://up.qiniup.com",
      "show-file-list": false,
      "on-success": _vm.handlePictureCardPreview,
      "before-upload": _vm.beforeAvatarUpload
    }
  }, [(_vm.dialogImageUrl) ? _c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.dialogImageUrl
    }
  }) : _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "状态："
    }
  }, [_c('el-switch', {
    attrs: {
      "active-value": 1,
      "inactive-value": 0
    },
    model: {
      value: (_vm.FaultClassForm.state),
      callback: function($$v) {
        _vm.$set(_vm.FaultClassForm, "state", $$v)
      },
      expression: "FaultClassForm.state"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(_vm.dialogMenuStatus !== 'update') ? _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.addEventFormSubmitBtn('FaultClassForm')
      }
    }
  }, [_vm._v("添加")]) : _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.saveEventFormSubmitBtn('FaultClassForm')
      }
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        return _vm.emptyDialog('FaultClassForm')
      }
    }
  }, [_vm._v("取 消")])], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/template-compiler?{"id":"data-v-1b3862b8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!/opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/selector.js?type=template&index=0!./src/views/recovery/recoveryPictures.vue
// module id = 1597
// module chunks = 0